import { NgModule } from '@angular/core';
import { DxPopupModule, DxTextBoxModule, DxBoxModule, DxDataGridModule, DxListModule } from 'devextreme-angular';
import { BrowserModule } from '@angular/platform-browser';
import { ApplicationPipesModule } from '../../../pipes/application-pipes.module';
import { CustomerVoteCardDeliveryOnEntranceDialogComponent } from './customer-vote-card-delivery-on-entrance-dialog.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [CustomerVoteCardDeliveryOnEntranceDialogComponent],
    imports: [
        BrowserModule,
        DxTextBoxModule,
        DxBoxModule,
        DxPopupModule,
        DxDataGridModule,
        DxListModule,
      ApplicationPipesModule,
        CommonModule
    ]

})
export class CustomerVoteCardDeliveryOnEntranceDialogModule {
}
